export enum LOADER_TYPE {
    MOVING_TRAY,
    FULL_PAGE,
    HALF_CARD,
}
